export const whatQuestions = [
  {
    questionNumber: 1,
    questionText: "What document do I need to bring to the interview?",
    choices: {
      A: "Your resume and a photo ID.",
      B: "The interview was yesterday.",
      C: "I applied online.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "면접에 어떤 서류를 가져가야 하나요?",
      choices: {
        A: "이력서와 사진이 있는 신분증을 가져가세요.",
        B: "면접은 어제였습니다.",
        C: "저는 온라인으로 지원했습니다.",
      },
    },
    explanation:
      "What 의문문에서는 구체적인 정보나 물건에 대해 답변해야 합니다. A는 면접에 가져가야 할 서류(이력서와 신분증)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 2,
    questionText: "What's the next step in the hiring process?",
    choices: {
      A: "Yes, I submitted my application.",
      B: "You'll have a phone interview next.",
      C: "I saw the job posting.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "채용 과정의 다음 단계는 무엇인가요?",
      choices: {
        A: "네, 지원서를 제출했습니다.",
        B: "다음에는 전화 인터뷰가 있을 것입니다.",
        C: "구인 공고를 봤습니다.",
      },
    },
    explanation:
      "What 의문문에서는 구체적인 정보나 절차에 대해 답변해야 합니다. B는 채용 과정의 다음 단계(전화 인터뷰)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 3,
    questionText: "What kind of refreshments will be served at the meeting?",
    choices: {
      A: "The meeting is in the conference room.",
      B: "I left the report on your desk.",
      C: "Coffee, tea, and pastries.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "회의에서 어떤 다과가 제공될 예정인가요?",
      choices: {
        A: "회의는 회의실에서 열립니다.",
        B: "보고서를 당신의 책상에 두었습니다.",
        C: "커피, 차, 그리고 페이스트리입니다.",
      },
    },
    explanation:
      "What 의문문에서는 구체적인 정보나 물건에 대해 답변해야 합니다. 'What kind of refreshments'는 '어떤 종류의 다과'를 묻는 질문으로, 다과의 종류에 대한 구체적인 정보를 요구합니다. A와 B는 각각 회의 장소와 보고서 위치에 관한 답변으로, 질문과 관련이 없습니다. C는 회의에서 제공될 다과(커피, 차, 페이스트리)에 대한 정확한 정보를 제공하고 있어 올바른 답변입니다. What으로 시작하는 질문에는 항상 구체적인 정보나 사물에 대한 답변이 필요합니다.",
  },

  {
    questionNumber: 4,
    questionText: "What project are you currently working on?",
    choices: {
      A: "I worked with her last year.",
      B: "The new product launch campaign.",
      C: "It should be done by Friday.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "현재 어떤 프로젝트를 진행 중이신가요?",
      choices: {
        A: "작년에 그녀와 함께 일했습니다.",
        B: "새 제품 출시 캠페인입니다.",
        C: "금요일까지 완료되어야 합니다.",
      },
    },
    explanation:
      "What 의문문에서는 구체적인 정보나 활동에 대해 답변해야 합니다. B는 현재 진행 중인 프로젝트(새 제품 출시 캠페인)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 5,
    questionText: "What time does the first session begin?",
    choices: {
      A: "It was very interesting.",
      B: "At 9:30 sharp.",
      C: "I'll attend the second one.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "첫 번째 세션은 몇 시에 시작하나요?",
      choices: {
        A: "매우 흥미로웠습니다.",
        B: "정확히 9시 30분입니다.",
        C: "저는 두 번째 세션에 참석할 것입니다.",
      },
    },
    explanation:
      "What time 의문문에서는 시간에 대한 정보를 답변해야 합니다. B는 첫 번째 세션의 시작 시간(9시 30분)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 6,
    questionText: "What's causing the delay in shipment?",
    choices: {
      A: "There was a problem at customs.",
      B: "I confirmed the delivery time.",
      C: "The shipment left this morning.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "배송 지연의 원인은 무엇인가요?",
      choices: {
        A: "세관에서 문제가 있었습니다.",
        B: "배송 시간을 확인했습니다.",
        C: "발송은 오늘 아침에 이루어졌습니다.",
      },
    },
    explanation:
      "What 의문문에서는 원인이나 이유에 대해 답변해야 합니다. A는 배송 지연의 원인(세관에서의 문제)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 7,
    questionText: "What room is the training being held in?",
    choices: {
      A: "Yes, it's mandatory.",
      B: "Room 304 on the third floor.",
      C: "It ends at noon.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "교육은 어느 방에서 진행되나요?",
      choices: {
        A: "네, 필수입니다.",
        B: "3층 304호실입니다.",
        C: "정오에 끝납니다.",
      },
    },
    explanation:
      "What room 의문문에서는 장소나 위치에 대한 정보를 답변해야 합니다. B는 교육이 진행되는 방(3층 304호실)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 8,
    questionText: "What did he say about the new design?",
    choices: {
      A: "The presentation is scheduled for Friday.",
      B: "He said it needs more color.",
      C: "I wasn't in that meeting.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그는 새 디자인에 대해 뭐라고 말했나요?",
      choices: {
        A: "프레젠테이션은 금요일로 예정되어 있습니다.",
        B: "그는 색상이 더 필요하다고 말했습니다.",
        C: "저는 그 회의에 참석하지 않았습니다.",
      },
    },
    explanation:
      "What did 의문문에서는 과거에 일어난 일이나 말에 대한 정보를 답변해야 합니다. B는 그가 새 디자인에 대해 한 말(색상이 더 필요하다)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 9,
    questionText: "What's the topic of today's seminar?",
    choices: {
      A: "Improving workplace communication.",
      B: "It's in the main auditorium.",
      C: "Yes, I already signed up.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "오늘 세미나의 주제는 무엇인가요?",
      choices: {
        A: "직장 내 의사소통 개선입니다.",
        B: "메인 강당에서 열립니다.",
        C: "네, 이미 등록했습니다.",
      },
    },
    explanation:
      "What 의문문에서는 주제나 내용에 대한 정보를 답변해야 합니다. A는 오늘 세미나의 주제(직장 내 의사소통 개선)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 10,
    questionText: "What day is the final report due?",
    choices: {
      A: "I've already submitted mine.",
      B: "It's due next Friday.",
      C: "It should be a short report.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "최종 보고서 제출 마감일은 언제인가요?",
      choices: {
        A: "저는 이미 제출했습니다.",
        B: "다음 금요일까지입니다.",
        C: "짧은 보고서여야 합니다.",
      },
    },
    explanation:
      "What day 의문문에서는 날짜나 요일에 대한 정보를 답변해야 합니다. B는 최종 보고서 제출 마감일(다음 금요일)에 대한 정보를 제공하고 있습니다.",
  },
  {
    questionNumber: 11,
    questionText: "What was the outcome of the negotiation?",
    choices: {
      A: "They're flying in next Monday.",
      B: "We reached a mutual agreement.",
      C: "Please print five more copies.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "협상의 결과는 무엇이었나요?",
      choices: {
        A: "그들은 다음 월요일에 비행기로 옵니다.",
        B: "우리는 상호 합의에 도달했습니다.",
        C: "5부 더 인쇄해 주세요.",
      },
    },
    explanation:
      "What was 의문문에서는 과거의 결과나 상황에 대한 정보를 답변해야 합니다. B는 협상의 결과(상호 합의에 도달)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 12,
    questionText: "What did the manager say about the proposal?",
    choices: {
      A: "The file was too large to send.",
      B: "He thinks it needs more data.",
      C: "That depends on the budget schedule.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "매니저가 제안에 대해 뭐라고 말했나요?",
      choices: {
        A: "파일이 너무 커서 보낼 수 없었습니다.",
        B: "그는 더 많은 데이터가 필요하다고 생각합니다.",
        C: "그것은 예산 일정에 달려 있습니다.",
      },
    },
    explanation:
      "What did 의문문에서는 과거에 한 말이나 행동에 대한 정보를 답변해야 합니다. B는 매니저가 제안에 대해 한 말(더 많은 데이터가 필요하다)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 13,
    questionText: "What happened at the product launch?",
    choices: {
      A: "There were more attendees than expected.",
      B: "We still don't know where it'll be.",
      C: "Make sure to lock the storage room.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "제품 출시 행사에서 무슨 일이 있었나요?",
      choices: {
        A: "예상보다 더 많은 참석자가 있었습니다.",
        B: "우리는 아직 그것이 어디서 열릴지 모릅니다.",
        C: "보관실을 잠그는 것을 확인하세요.",
      },
    },
    explanation:
      "What happened 의문문에서는 과거에 발생한 사건이나 상황에 대한 정보를 답변해야 합니다. A는 제품 출시 행사에서 일어난 일(예상보다 많은 참석자)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 14,
    questionText: "What did she decide about the marketing plan?",
    choices: {
      A: "She said it wasn't effective.",
      B: "The office closes at 6 p.m.",
      C: "Let me send you the slides.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "그녀가 마케팅 계획에 대해 어떤 결정을 내렸나요?",
      choices: {
        A: "그녀는 그것이 효과적이지 않다고 말했습니다.",
        B: "사무실은 오후 6시에 닫습니다.",
        C: "슬라이드를 보내드리겠습니다.",
      },
    },
    explanation:
      "What did 의문문에서는 과거의 결정이나 행동에 대한 정보를 답변해야 합니다. A는 그녀가 마케팅 계획에 대해 내린 결정(효과적이지 않다고 판단)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 15,
    questionText: "What did they say about the new policy?",
    choices: {
      A: "I'm running late for the appointment.",
      B: "They were generally supportive.",
      C: "We're opening a new branch next year.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그들이 새 정책에 대해 뭐라고 말했나요?",
      choices: {
        A: "약속에 늦고 있습니다.",
        B: "그들은 대체로 지지적이었습니다.",
        C: "우리는 내년에 새 지점을 열 예정입니다.",
      },
    },
    explanation:
      "What did 의문문에서는 과거에 한 말이나 의견에 대한 정보를 답변해야 합니다. B는 그들이 새 정책에 대해 한 말(대체로 지지적)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 16,
    questionText: "What was the result of the performance review?",
    choices: {
      A: "He'll be promoted to senior analyst.",
      B: "Can you pass me the stapler?",
      C: "She's preparing the monthly budget.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "성과 평가의 결과는 무엇이었나요?",
      choices: {
        A: "그는 시니어 애널리스트로 승진할 예정입니다.",
        B: "스테이플러를 건네주시겠어요?",
        C: "그녀는 월간 예산을 준비하고 있습니다.",
      },
    },
    explanation:
      "What was 의문문에서는 과거의 결과나 상황에 대한 정보를 답변해야 합니다. A는 성과 평가의 결과(시니어 애널리스트로 승진)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 17,
    questionText: "What did the CEO mention about next year's plan?",
    choices: {
      A: "He's considering budget cuts.",
      B: "That's not in the folder.",
      C: "I didn't attend the seminar.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "CEO가 내년 계획에 대해 무엇을 언급했나요?",
      choices: {
        A: "그는 예산 삭감을 고려하고 있습니다.",
        B: "그것은 폴더에 없습니다.",
        C: "저는 세미나에 참석하지 않았습니다.",
      },
    },
    explanation:
      "What did 의문문에서는 과거에 언급한 내용이나 말에 대한 정보를 답변해야 합니다. A는 CEO가 내년 계획에 대해 언급한 내용(예산 삭감 고려)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 18,
    questionText: "What did the technician say about the equipment?",
    choices: {
      A: "It needs to be replaced.",
      B: "Could you help me with this email?",
      C: "The cafeteria's closed today.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "기술자가 장비에 대해 뭐라고 말했나요?",
      choices: {
        A: "교체가 필요합니다.",
        B: "이 이메일을 도와주시겠어요?",
        C: "오늘 구내식당은 닫았습니다.",
      },
    },
    explanation:
      "What did 의문문에서는 과거에 한 말이나 의견에 대한 정보를 답변해야 합니다. A는 기술자가 장비에 대해 한 말(교체 필요)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 19,
    questionText: "What was the feedback on the presentation?",
    choices: {
      A: "They asked for a simpler layout.",
      B: "He'll arrive in 10 minutes.",
      C: "I didn't check my schedule yet.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "프레젠테이션에 대한 피드백은 무엇이었나요?",
      choices: {
        A: "그들은 더 단순한 레이아웃을 요청했습니다.",
        B: "그는 10분 안에 도착할 예정입니다.",
        C: "아직 일정을 확인하지 않았습니다.",
      },
    },
    explanation:
      "What was 의문문에서는 과거의 피드백이나 의견에 대한 정보를 답변해야 합니다. A는 프레젠테이션에 대한 피드백(더 단순한 레이아웃 요청)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 20,
    questionText: "What did Tom say about the client's request?",
    choices: {
      A: "He forwarded it to the design team.",
      B: "I'm not available this afternoon.",
      C: "That's not in the manual.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "톰이 고객의 요청에 대해 뭐라고 말했나요?",
      choices: {
        A: "그는 그것을 디자인 팀에 전달했습니다.",
        B: "저는 오후에 시간이 없습니다.",
        C: "그것은 매뉴얼에 없습니다.",
      },
    },
    explanation:
      "What did 의문문에서는 과거에 한 말이나 행동에 대한 정보를 답변해야 합니다. A는 톰이 고객의 요청에 대해 한 말(디자인 팀에 전달)에 대한 정보를 제공하고 있습니다.",
  },
  {
    questionNumber: 21,
    questionText: "What did she say about the final report?",
    choices: {
      A: "She wants to revise the introduction.",
      B: "That's located on the third floor.",
      C: "Please bring your ID tomorrow.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "그녀가 최종 보고서에 대해 뭐라고 말했나요?",
      choices: {
        A: "그녀는 서론을 수정하고 싶어합니다.",
        B: "그것은 3층에 위치해 있습니다.",
        C: "내일 신분증을 가져오세요.",
      },
    },
    explanation:
      "What did 의문문에서는 과거에 한 말이나 의견에 대한 정보를 답변해야 합니다. A는 그녀가 최종 보고서에 대해 한 말(서론 수정 희망)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 22,
    questionText: "What was the reaction to our proposal?",
    choices: {
      A: "We're moving to a different platform.",
      B: "They seemed quite interested.",
      C: "It opens at 9 a.m. on weekdays.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "우리 제안에 대한 반응은 어땠나요?",
      choices: {
        A: "우리는 다른 플랫폼으로 이동하고 있습니다.",
        B: "그들은 꽤 관심이 있어 보였습니다.",
        C: "평일에는 오전 9시에 개장합니다.",
      },
    },
    explanation:
      "What was 의문문에서는 과거의 반응이나 상황에 대한 정보를 답변해야 합니다. B는 제안에 대한 반응(관심을 보임)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 23,
    questionText: "What did the technician say about the server issue?",
    choices: {
      A: "He's still investigating the problem.",
      B: "I already sent the invitation.",
      C: "That depends on the location.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "기술자가 서버 문제에 대해 뭐라고 말했나요?",
      choices: {
        A: "그는 아직 문제를 조사 중입니다.",
        B: "저는 이미 초대장을 보냈습니다.",
        C: "그것은 위치에 따라 다릅니다.",
      },
    },
    explanation:
      "What did 의문문에서는 과거에 한 말이나 행동에 대한 정보를 답변해야 합니다. A는 기술자가 서버 문제에 대해 한 말(아직 조사 중)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 24,
    questionText: "What was the result of the audit?",
    choices: {
      A: "We passed with no issues.",
      B: "It's near the cafeteria.",
      C: "I'll be there in an hour.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "감사의 결과는 어땠나요?",
      choices: {
        A: "우리는 문제 없이 통과했습니다.",
        B: "그것은 구내식당 근처에 있습니다.",
        C: "한 시간 안에 그곳에 도착하겠습니다.",
      },
    },
    explanation:
      "What was 의문문에서는 과거의 결과나 상황에 대한 정보를 답변해야 합니다. A는 감사 결과(문제 없이 통과)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 25,
    questionText: "What did your supervisor mention about the deadline?",
    choices: {
      A: "She extended it by two days.",
      B: "The documents are on your desk.",
      C: "That room is already reserved.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "당신의 상사가 마감일에 대해 무엇을 언급했나요?",
      choices: {
        A: "그녀는 이틀 연장했습니다.",
        B: "서류들이 당신의 책상 위에 있습니다.",
        C: "그 방은 이미 예약되어 있습니다.",
      },
    },
    explanation:
      "What did 의문문에서는 과거에 한 말이나 언급에 대한 정보를 답변해야 합니다. A는 상사가 마감일에 대해 언급한 내용(이틀 연장)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 26,
    questionText: "What did he think of the new software?",
    choices: {
      A: "It's installed on the third floor.",
      B: "He said it was more user-friendly.",
      C: "Let's go over the budget again.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그는 새 소프트웨어에 대해 어떻게 생각했나요?",
      choices: {
        A: "3층에 설치되어 있습니다.",
        B: "그는 더 사용자 친화적이라고 말했습니다.",
        C: "예산을 다시 검토해 봅시다.",
      },
    },
    explanation:
      "What did 의문문에서는 과거의 생각이나 의견에 대한 정보를 답변해야 합니다. B는 그가 소프트웨어에 대해 생각한 내용(더 사용자 친화적)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 27,
    questionText: "What did the client ask for during the meeting?",
    choices: {
      A: "A copy of the final invoice.",
      B: "The report is almost ready.",
      C: "I'll join the call after lunch.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의 중에 고객이 무엇을 요청했나요?",
      choices: {
        A: "최종 청구서 사본.",
        B: "보고서가 거의 준비되었습니다.",
        C: "점심 식사 후에 통화에 참여하겠습니다.",
      },
    },
    explanation:
      "What did 의문문에서는 과거에 한 요청이나 행동에 대한 정보를 답변해야 합니다. A는 고객이 회의 중에 요청한 것(최종 청구서 사본)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 28,
    questionText: "What did she say about the job candidate?",
    choices: {
      A: "She's reviewing the schedule.",
      B: "He seems like a good fit.",
      C: "Please email the agenda.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그녀가 구직 후보자에 대해 뭐라고 말했나요?",
      choices: {
        A: "그녀는 일정을 검토 중입니다.",
        B: "그는 적합해 보입니다.",
        C: "의제를 이메일로 보내주세요.",
      },
    },
    explanation:
      "What did 의문문에서는 과거에 한 말이나 의견에 대한 정보를 답변해야 합니다. B는 그녀가 구직 후보자에 대해 한 말(적합해 보임)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 29,
    questionText: "What was the main topic of yesterday's workshop?",
    choices: {
      A: "Strategies for effective communication.",
      B: "That printer isn't working again.",
      C: "We're going to lunch soon.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "어제 워크숍의 주요 주제는 무엇이었나요?",
      choices: {
        A: "효과적인 의사소통을 위한 전략.",
        B: "그 프린터가 또 작동하지 않습니다.",
        C: "곧 점심 식사를 하러 갑니다.",
      },
    },
    explanation:
      "What was 의문문에서는 과거의 주제나 내용에 대한 정보를 답변해야 합니다. A는 워크숍의 주요 주제(효과적인 의사소통 전략)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 30,
    questionText: "What did Mr. Lee say about the schedule change?",
    choices: {
      A: "He approved the new timeline.",
      B: "It's available online now.",
      C: "That printer isn't working again.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이 씨가 일정 변경에 대해 뭐라고 말했나요?",
      choices: {
        A: "그는 새 일정을 승인했습니다.",
        B: "지금 온라인에서 이용 가능합니다.",
        C: "그 프린터가 또 작동하지 않습니다.",
      },
    },
    explanation:
      "What did 의문문에서는 과거에 한 말이나 결정에 대한 정보를 답변해야 합니다. A는 이 씨가 일정 변경에 대해 한 말(새 일정 승인)에 대한 정보를 제공하고 있습니다.",
  },
  {
    questionNumber: 31,
    questionText: "What time is the meeting scheduled for?",
    choices: {
      A: "At 2 p.m.",
      B: "With the finance manager.",
      C: "In the main office.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의는 몇 시로 예정되어 있나요?",
      choices: {
        A: "오후 2시입니다.",
        B: "재무 관리자와 함께입니다.",
        C: "본사에서입니다.",
      },
    },
    explanation:
      "What time 의문문에서는 시간에 대한 정보를 답변해야 합니다. A는 회의 시간(오후 2시)에 대한 정확한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 32,
    questionText: "What time should I leave for the airport?",
    choices: {
      A: "The flight is full.",
      B: "About three hours before departure.",
      C: "With your passport and ID.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "공항에 몇 시에 출발해야 하나요?",
      choices: {
        A: "항공편이 만석입니다.",
        B: "출발 약 3시간 전에요.",
        C: "여권과 신분증을 지참하세요.",
      },
    },
    explanation:
      "What time 의문문에서는 시간에 대한 정보를 답변해야 합니다. B는 공항에 출발해야 하는 시간(출발 약 3시간 전)에 대한 정보를 제공하고 있습니다.",
  },
  {
    questionNumber: 33,
    questionText: "What time does the workshop begin?",
    choices: {
      A: "The projector isn't working.",
      B: "It starts promptly at nine.",
      C: "In the auditorium.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "워크숍은 몇 시에 시작하나요?",
      choices: {
        A: "프로젝터가 작동하지 않습니다.",
        B: "정확히 9시에 시작합니다.",
        C: "강당에서 열립니다.",
      },
    },
    explanation:
      "What time 의문문에서는 시간에 대한 정보를 답변해야 합니다. 'What time'은 '몇 시에'라는 의미로, 특정 시간을 묻는 질문입니다. A는 프로젝터 상태에 관한 정보로 시간과 관련이 없고, C는 장소에 관한 정보로 시간과 관련이 없습니다. B는 워크숍 시작 시간(정확히 9시)에 대한 정확한 정보를 제공하고 있어 올바른 답변입니다. 시간을 묻는 What time 질문에는 항상 구체적인 시간이나 시점에 대한 답변이 필요합니다.",
  },

  {
    questionNumber: 34,
    questionText: "What time do I need to submit the application?",
    choices: {
      A: "Before the end of the day.",
      B: "With the correct documents.",
      C: "Through the online system.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "지원서를 언제까지 제출해야 하나요?",
      choices: {
        A: "오늘 업무 종료 전까지입니다.",
        B: "올바른 서류와 함께 제출하세요.",
        C: "온라인 시스템을 통해 제출하세요.",
      },
    },
    explanation:
      "What time 의문문에서는 시간이나 기한에 대한 정보를 답변해야 합니다. A는 지원서 제출 기한(오늘 업무 종료 전)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 35,
    questionText: "What time is your interview with the director?",
    choices: {
      A: "My resume is ready.",
      B: "It's at 10:30 in the morning.",
      C: "On the 5th floor.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "이사님과의 면접은 몇 시인가요?",
      choices: {
        A: "제 이력서는 준비되어 있습니다.",
        B: "오전 10시 30분입니다.",
        C: "5층에서 진행됩니다.",
      },
    },
    explanation:
      "What time 의문문에서는 시간에 대한 정보를 답변해야 합니다. B는 면접 시간(오전 10시 30분)에 대한 정확한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 36,
    questionText: "What time are we expected at the client's office?",
    choices: {
      A: "When the documents are signed.",
      B: "By 3 p.m.",
      C: "Using the company car.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "고객사 사무실에 몇 시까지 도착해야 하나요?",
      choices: {
        A: "서류에 서명이 완료되면요.",
        B: "오후 3시까지입니다.",
        C: "회사 차량을 이용해서요.",
      },
    },
    explanation:
      "What time 의문문에서는 시간에 대한 정보를 답변해야 합니다. B는 고객사 사무실 도착 시간(오후 3시까지)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 37,
    questionText: "What time will the keynote speech end?",
    choices: {
      A: "At around 5 p.m.",
      B: "The photographer is setting up now.",
      C: "In the main conference room.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "기조 연설은 몇 시에 끝나나요?",
      choices: {
        A: "오후 5시경입니다.",
        B: "사진작가가 지금 준비하고 있습니다.",
        C: "메인 컨퍼런스룸에서 진행됩니다.",
      },
    },
    explanation:
      "What time 의문문에서는 시간에 대한 정보를 답변해야 합니다. 'What time will the keynote speech end?'는 '기조 연설이 몇 시에 끝나나요?'라는 질문으로, 종료 시간에 대한 구체적인 정보를 요구합니다. A는 기조 연설 종료 시간(오후 5시경)에 대한 명확한 정보를 제공하고 있어 올바른 답변입니다. B는 시간과 관련 없는 정보를 제공하고 있어 부적절합니다. C는 시간이 아닌 장소에 대한 정보를 제공하고 있어 질문에 적절히 대답하지 못하고 있습니다.",
  },

  {
    questionNumber: 38,
    questionText: "What time should I call Mr. Tanaka?",
    choices: {
      A: "After he returns from lunch.",
      B: "His number is on the memo.",
      C: "In Japanese, preferably.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "다나카 씨에게 언제 전화해야 하나요?",
      choices: {
        A: "그가 점심 식사에서 돌아온 후에요.",
        B: "그의 번호는 메모에 있습니다.",
        C: "가능하면 일본어로 통화하세요.",
      },
    },
    explanation:
      "What time 의문문에서는 시간이나 시점에 대한 정보를 답변해야 합니다. A는 전화해야 할 시점(점심 식사 후)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 39,
    questionText: "What time does the bus to the factory leave?",
    choices: {
      A: "The seats are reserved.",
      B: "It departs from gate 2.",
      C: "At 7:15 sharp.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "공장으로 가는 버스는 몇 시에 출발하나요?",
      choices: {
        A: "좌석은 예약되어 있습니다.",
        B: "2번 게이트에서 출발합니다.",
        C: "정확히 7시 15분에 출발합니다.",
      },
    },
    explanation:
      "What time 의문문에서는 시간에 대한 정보를 답변해야 합니다. C는 버스 출발 시간(정확히 7시 15분)에 대한 정보를 제공하고 있습니다.",
  },

  {
    questionNumber: 40,
    questionText: "What time can I expect the delivery?",
    choices: {
      A: "Please confirm the address.",
      B: "The warehouse closes at five.",
      C: "Between 1 and 3 p.m.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "배송은 언제쯤 도착할 예정인가요?",
      choices: {
        A: "주소를 확인해 주세요.",
        B: "창고는 5시에 닫습니다.",
        C: "오후 1시에서 3시 사이입니다.",
      },
    },
    explanation:
      "What time 의문문에서는 시간에 대한 정보를 답변해야 합니다. C는 배송 예상 시간(오후 1시에서 3시 사이)에 대한 정보를 제공하고 있습니다.",
  },
];
